export const LAUNCH_DATE = new Date('2026-06-29T23:59:59');

export const FEEDBACK_ENGAGEMENT_SECONDS = 90;
export const FEEDBACK_MIN_PAGE_VIEWS = 2;
export const TRAFFIC_SOURCE_DELAY_SECONDS = 10;

/** Minimum gap between any two popups (ms) */
export const POPUP_COOLDOWN_MS = 12000;

/** Exit intent only after traffic modal was dismissed + this many seconds */
export const EXIT_INTENT_MIN_DELAY_AFTER_TRAFFIC_SECONDS = 20;

export const SHOPPING_INTERESTS = [
  'Furniture',
  'Décor',
  'Fragrance',
  'Gift Items',
  'Other',
];

export const TRAFFIC_SOURCES = [
  'Instagram',
  'TikTok',
  'Facebook',
  'Google',
  'Referral',
  'Other',
];

export const SURVEY_STYLES = [
  'Modern',
  'Classic',
  'Minimalist',
  'Bohemian',
  'Other',
];

export const SURVEY_ROOM_TYPES = [
  'Living Room',
  'Bedroom',
  'Kitchen',
  'Office',
  'Other',
];
